export default {
    'zh_CN': {

        'custom.type.type.dictionary': ()=>[{value:2,label:'入场'},{value:1,label:'出场'}],
        'custom.type.type.dictionary.label' : '进出类型'
    },
    'zh_TW': {

    },
    'en_US': {

    }
}
